import { gql } from '@apollo/client';

export const TREATMENTGROUP = gql`
  fragment treatmentGroup on TreatmentGroup {
    id
    firstName
    lastName
    persalNumber
    nationalID
    district {
      id
      name
    }
    institutions {
      id
      name
      emisNumber
    }
    primaryInstitution {
      id
      name
      emisNumber
    }
    grades {
      id
      value
      name
    }
    phase {
      id
      name
    }
    personnelPosition {
      id
      name
    }
    personnelPositionOther
  }
`;
